// When a NG_APP_* key has no matching value in .env, @ngx-env/builder leaves the
// raw `process.env[...]` expression in the browser bundle instead of inlining it,
// which throws a ReferenceError (`process` doesn't exist in the browser) as soon as
// this module loads. Reading through a lazily-evaluated getter lets us catch that
// per key, so one missing variable doesn't take down the whole app.
function readEnv(key: string, getter: () => string): string {
  try {
    return getter();
  } catch {
    console.error(`[environment] Missing environment variable ${key} — check your .env file.`);
    return '';
  }
}

// Optional flags: absent means off, without an error in the console.
function readFlag(getter: () => string | undefined): boolean {
  try {
    return getter() === 'true';
  } catch {
    return false;
  }
}

const NG_APP_ENV = readEnv('NG_APP_ENV', () => process.env['NG_APP_ENV']);
const isDev = NG_APP_ENV === 'dev';

export const environment = {
  production: NG_APP_ENV === 'production',
  AUTH_API: readEnv('NG_APP_AUTH_API', () => process.env['NG_APP_AUTH_API']),
  AUTH_CONSUMER: 'unifield-api',
  // Refonte auth (UF-2711): sign in through auth-api (OIDC) via the BFF served under /bff.
  OIDC: readFlag(() => process.env['NG_APP_OIDC']),
  API_URL: readEnv('NG_APP_API_URL', () => process.env['NG_APP_API_URL']),
  DEV_API_URL: readEnv('NG_APP_DEV_API_URL', () => process.env['NG_APP_DEV_API_URL']),
  FLOW_URL: readEnv('NG_APP_FLOW_URL', () => process.env['NG_APP_FLOW_URL']),
  FLOW_REPLAY_URL: readEnv('NG_APP_FLOW_REPLAY_URL', () => process.env['NG_APP_FLOW_REPLAY_URL']),
  MEDIA_URL: readEnv('NG_APP_MEDIA_URL', () => process.env['NG_APP_MEDIA_URL']),
  MEDIA_URL_DEV: readEnv('NG_APP_MEDIA_URL_DEV', () => process.env['NG_APP_MEDIA_URL_DEV']),
  WEATHER_API_KEY: readEnv('NG_APP_WEATHER_API_KEY', () => process.env['NG_APP_WEATHER_API_KEY']),
  GOOGLE_MAPS_KEY: readEnv('NG_APP_GOOGLE_MAPS_KEY', () => process.env['NG_APP_GOOGLE_MAPS_KEY']),
  version: readEnv('NG_APP_VERSION', () => process.env['NG_APP_VERSION']),
};
